import { useDateRangePickerContext } from '../context/DateRangePickerContext';
import { useMonthRangeState } from '../hooks/useMonthRangeState';
import { PresetSidebar } from '../components/PresetSidebar';
import { MonthGridView } from '../components/MonthGridView/MonthGridView';
import { ActionButtons } from '../components/ActionButtons';

export function MonthlyPicker() {
  const { value, onChange, onClose, presetOptions, showPresets, hideButtons, minDate, maxDate, fixedNumberOfMonth } =
    useDateRangePickerContext();

  const state = useMonthRangeState({
    value,
    onChange: v => {
      onChange(v);
      if (v.range.presetValue !== 'custom') {
        onClose();
      }
    },
    onCancel: onClose,
    fixedNumberOfMonth,
    hideButtons,
    maxDate,
  });

  const { draft } = state;
  const showApplyCancel = !hideButtons || draft.range.presetValue === 'custom';

  return (
    <>
      <div className="flex justify-between items-start border-b border-gray-200">
        {showPresets && (
          <div className="flex flex-col flex-shrink-0 w-[200px] min-h-[430px] border-r border-gray-300">
            <PresetSidebar
              onChange={state.handlePresetChange}
              value={draft.range.presetValue}
              options={presetOptions}
              className="pt-6 border-r-0"
            />
          </div>
        )}

        <MonthGridView
          selectedRange={{ from: draft.range.from, to: draft.range.to }}
          minDate={minDate}
          maxDate={maxDate}
          menuYear={state.menuYear}
          onYearChange={state.setMenuYear}
          onMonthClick={state.handleMonthClick}
          onMonthHover={state.handleMonthHover}
          rangePending={state.rangePending}
        />
      </div>

      <ActionButtons
        onApply={() => {
          state.handleApply();
          onClose();
        }}
        onCancel={onClose}
        applyDisabled={!draft.range.from || !draft.range.to}
        invisible={!showApplyCancel}
      />
    </>
  );
}
